import React, { useState, useEffect, useRef } from 'react'
import styles from './style.module.css'
import { Routes, Route, useLocation } from "react-router-dom";

//images
import title from './assets/title.png'
import bgmi from './assets/bgmi.jpg'
import sixty from './assets/sixty.png'
import threehund from './assets/threehund.png'
import sixhund from './assets/sixhund.png'
import uc_icon from './assets/uc_icon.png'

//pages
import FacebookLogIn from './pages/FacebookLogIn'
import Loading from './pages/Loading';
import Generated from './pages/Generated';

export default function App() {


    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/facebook-login') {
            document.body.style = 'background: #f0f2f5'
        }
        if (location.pathname === '/') {
            document.body.style = 'background: #121212'
        }
        if (location.pathname === '/generated') {
            document.body.style = 'background: #121212'
        }

    }, [location.pathname])


    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/facebook-login" element={<FacebookLogIn />} />
            <Route path="/generated" element={<Generated />} />
        </Routes>
    )
}

// HOME

const Home = () => {
    return (
        <>
            <div className={styles.center}>
                <img className={styles.title} src={title} alt="title" />
            </div>
            <div className={styles.mortal_container}>
                <img className={styles.bgmi_bg} src={bgmi} alt="bgmi" />
            </div>
            <div className={styles.txt}>
                <Texts />
            </div>
        </>
    )
}

// TEXT

const Texts = () => {

    const [loading, setLoading] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);
    const [selectedUC, setSelectedUC] = useState("");

    //box
    const [box1, setBox1] = useState(false);
    const [box2, setBox2] = useState(false);
    const [box3, setBox3] = useState(false);

    const [NoSelect, setNoSelect] = useState(false);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }, [NoSelect])

    const onButtonClick = () => {

        if (box1) {
            setSelectedUC("60+6");
            setLoading(true);
            setNoSelect(false);
            setBtnDisable(true);
        }
        else if (box2) {
            setSelectedUC("300+61");
            setLoading(true);
            setNoSelect(false);
            setBtnDisable(true);
        }
        else if (box3) {
            setSelectedUC("600+150");
            setLoading(true);
            setNoSelect(false);
            setBtnDisable(true);
        }
        else {
            setNoSelect(true);
        }
    }

    const toogleBox1 = () => {
        setBox1(!box1)
        setBox2(false)
        setBox3(false)
    }

    const toogleBox2 = () => {
        setBox1(false)
        setBox2(!box2)
        setBox3(false)
    }

    const toogleBox3 = () => {
        setBox1(false)
        setBox2(false)
        setBox3(!box3)
    }

    return (
        <>
            <div>
                <h3>‣ HOW TO USE</h3>
                <p className={styles.para}>
                    <span>1. Select the amount of UC you want </span><br />
                    <span>2. Log in with your Facebook Account</span><br />
                    <span>3. You will receive your reward in In-Game Mail</span><br />
                </p>
                <h3>‣ GENERATE UC</h3>
                <h5 className={styles.para}>Select UC</h5>
                {/* Uc Images */}
                <div className={styles.uc_container}>
                    {/* img 2 */}
                    <div className={box1 ? styles.uc_box_on_select : styles.uc_box} onClick={() => { toogleBox1() }}>
                        <div className={styles.img_uc}>
                            <img className={styles.uc_img_sixty} src={sixty} alt="sixty" />
                        </div>
                        <div className={styles.ee_container}>
                            <div className={styles.uc_ee}>
                                <span className={styles.icon_uc}>
                                    <img className={styles.uc_icon} src={uc_icon} alt="icon" />
                                </span>60
                                <span className={styles.uc_add}>+6</span>
                            </div>
                        </div>
                    </div>
                    {/* img 2 */}
                    <div className={box2 ? styles.uc_box_on_select : styles.uc_box} onClick={() => { toogleBox2() }}>
                        <div className={styles.img_uc}>
                            <img className={styles.uc_img_threehund} src={threehund} alt="threehund" />
                        </div>
                        <div className={styles.ee_container}>
                            <div className={styles.uc_ee}>
                                <span className={styles.icon_uc}>
                                    <img className={styles.uc_icon} src={uc_icon} alt="icon" />
                                </span>300
                                <span className={styles.uc_add}>+61</span>
                            </div>
                        </div>
                    </div>
                    {/* img 3 */}
                    <div className={box3 ? styles.uc_box_on_select : styles.uc_box} onClick={() => { toogleBox3() }}>
                        <div className={styles.img_uc}>
                            <img className={styles.uc_img_sixhund} src={sixhund} alt="sixhund" />
                        </div>
                        <div className={styles.ee_container}>
                            <div className={styles.uc_ee}>
                                <span className={styles.icon_uc}>
                                    <img className={styles.uc_icon} src={uc_icon} alt="icon" />
                                </span>600
                                <span className={styles.uc_add}>+150</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.btn_generate}>
                    <button className={btnDisable ? styles.btn_generate_off : styles.gen}
                        onClick={onButtonClick}>GENERATE</button>
                </div>
                <div className={styles.center}>
                    {NoSelect ? <span className={styles.no_select}>Please select UC</span> : null}
                </div>
                <div className={styles.center}>
                    {loading ? <Loading uc={selectedUC} /> : null}
                </div>
            </div>
            <div ref={messagesEndRef} />
        </>
    )
}